import { dashboardActionTypes, userActionTypes } from './types';
import { dashboardService } from '../services';

const isExpiredTokenError = error => (
  error
  && (
    error.code === 'invalidToken'
    || error.name === 'TokenExpiredError'
    || error.error === 'jwt expired'
  )
);

const failureAction = (error, pendingRefreshToken, type) => {
  if (isExpiredTokenError(error)) {
    return pendingRefreshToken
      ? { type: userActionTypes.PENDING_REFRESH_TOKEN, error: error.error }
      : { type: userActionTypes.INVALID_TOKEN, error: error.error };
  }

  return {
    type,
    error: (error && (error.error || error.message)) || 'Dashboard request failed',
  };
};

const getSummary = () => {
  return (dispatch, getState) => {
    dispatch(request());

    return dashboardService.getSummary().then(
      summary => dispatch({
        type: dashboardActionTypes.SUMMARY_SUCCESS,
        summary,
      }),
      error => dispatch(failureAction(
        error,
        getState().authentication.pendingRefreshingToken,
        dashboardActionTypes.SUMMARY_FAILURE,
      )),
    );
  };

  function request() {
    return { type: dashboardActionTypes.SUMMARY_REQUEST };
  }
};

const getCharts = query => {
  return (dispatch, getState) => {
    const requestKey = JSON.stringify(query || {});
    dispatch(request());

    return dashboardService.getCharts(query).then(
      charts => dispatch({
        type: dashboardActionTypes.CHARTS_SUCCESS,
        charts,
        requestKey,
      }),
      error => dispatch({
        ...failureAction(
          error,
          getState().authentication.pendingRefreshingToken,
          dashboardActionTypes.CHARTS_FAILURE,
        ),
        requestKey,
      }),
    );

    function request() {
      return {
        type: dashboardActionTypes.CHARTS_REQUEST,
        requestKey,
      };
    }
  };
};

const refresh = query => dispatch => Promise.all([
  dispatch(getSummary()),
  dispatch(getCharts(query)),
]);

export const dashboardActions = {
  getSummary,
  getCharts,
  refresh,
};
